import { useDispatch, useSelector } from 'react-redux';
import { currentButton, sidebarActions, sidebarButtons } from '../../store/sidebar.slice';
import { ReactComponent as InventoryLogo } from '../../svg/wysiwyg.svg';
import { ReactComponent as StoreSettingsLogo } from '../../svg/storeSettings.svg';
import { ReactComponent as PromotionsLogo } from '../../svg/promotions.svg';
import { ReactComponent as CouponsLogo } from '../../svg/coupons.svg';
import {
  HeaderTypography,
  ButtonList,
  InventoryButton,
  ListText,
  InventoryTypography,
  SidebarButtons,
  SidebarIcon,
  SidebarContainer,
  ModifiersTypography,
  InventoryButtons,
  ButtonsTypography,
  InventoryButtonList,
  LogoutButtonContainer
} from './sidebar.styles';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { productsActions } from '../../store/products';
import { LogoutOkta } from '../../auth/okta-login';

export function Sidebar(): JSX.Element {
  const dispatch = useDispatch();
  const currentPressedButton = useSelector(currentButton);
  const navigate = useNavigate();

  function buttonClickedHandler(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    button: sidebarButtons
  ): void {
    dispatch(sidebarActions.changeCurrentlyShowing(button));
    navigate(`${button}`, { replace: true });
    resetStates(button);
  }

  function resetStates(button: sidebarButtons) {
    switch (button) {
      case 'products':
        dispatch(productsActions.restartQueryParams());
        if (currentPressedButton === 'products') {
          dispatch(productsActions.getProducts());
        }
        break;
      default:
        break;
    }
  }

  return (
    <SidebarContainer>
      <HeaderTypography>Homesome</HeaderTypography>
      <InventoryButtonList>
        <InventoryButton
          id='sidebarInventory'
          key='inventory'
          disableRipple={true}
          disableTouchRipple={true}
        >
          <SidebarIcon>
            <InventoryLogo
              fill={
                currentPressedButton === 'products' || currentPressedButton === 'modifiers'
                  ? '#A3A7FA'
                  : 'white'
              }
            />
          </SidebarIcon>
          <ListText primary={<InventoryTypography>Inventory</InventoryTypography>} />
        </InventoryButton>
        <InventoryButtons
          id='sidebarProducts'
          key='products'
          onClick={(event) => buttonClickedHandler(event, 'products')}
          selected={currentPressedButton === 'products'}
          disableRipple={true}
          disableTouchRipple={true}
        >
          <ListText primary={<ModifiersTypography>Products</ModifiersTypography>} />
        </InventoryButtons>
        <InventoryButtons
          id='sidebarModifiers'
          key='modifiers'
          onClick={(event) => buttonClickedHandler(event, 'modifiers')}
          selected={currentPressedButton === 'modifiers'}
          disableRipple={true}
          disableTouchRipple={true}
        >
          <ListText primary={<ModifiersTypography>Modifiers</ModifiersTypography>} />
        </InventoryButtons>
        <InventoryButtons
          id='sidebarHealthClaims'
          key='healthClaims'
          disableRipple={true}
          disableTouchRipple={true}
          disabled
        >
          <ListText primary={<ModifiersTypography>Health Claims</ModifiersTypography>} />
        </InventoryButtons>
      </InventoryButtonList>
      <ButtonList>
        <SidebarButtons id='sidebarStoreSettings' key='storeSettings' disabled>
          <SidebarIcon>
            <StoreSettingsLogo />
          </SidebarIcon>
          <ListText primary={<ButtonsTypography>Store settings</ButtonsTypography>} />
        </SidebarButtons>
        <SidebarButtons id='sidebarPromotions' key='promotions' disabled>
          <SidebarIcon>
            <PromotionsLogo />
          </SidebarIcon>
          <ListText primary={<ButtonsTypography>Promotions</ButtonsTypography>} />
        </SidebarButtons>
        <SidebarButtons id='sidebarCoupons' key='coupons' disabled>
          <SidebarIcon>
            <CouponsLogo />
          </SidebarIcon>
          <ListText primary={<ButtonsTypography>Coupons</ButtonsTypography>} />
        </SidebarButtons>
      </ButtonList>
      {!window.Cypress && (
        <LogoutButtonContainer id='logout-button-container'>
          <LogoutOkta />
        </LogoutButtonContainer>
      )}
    </SidebarContainer>
  );
}
